import {
  createTheme,
  darkTheme,
  lightTheme,
  genPageTheme,
  shapes,
  BaseThemeOptionsInput
} from "@backstage/theme";


export const leoDarkTheme = createTheme({
  defaultPageTheme: "home",
  palette: {
    ...darkTheme.palette,
    primary: {
      main: "#6475ce",
      light: "#cbcbcb",
      dark: "#225588"
    },
    secondary: {
      main: "#f38925",
      dark: "#573810",
      light: "#ffe6c0",
      contrastText: "#e0e0e0"
    },
    info: {
      main: "#4564e5",
      contrastText: "#e0e0e0"
    },
    background: {
      paper: "#424242"
    },

  },

  fontFamily: 'Roboto, sans-serif',
  pageTheme: {
    home: genPageTheme(
      {
        colors: ['#CC5500','#f38925'],
        shape: shapes.wave
      })
  }
} as BaseThemeOptionsInput<any>)

export const leoLightTheme = createTheme({
  defaultPageTheme: "home",
  fontFamily: 'Roboto, sans-serif',
  pageTheme: {
    home: genPageTheme(
      {
        colors: ['#CC5500', '#f38925'],
        shape: shapes.wave
      }
    )
  },
  palette: {
    ...lightTheme.palette,
    primary: {
      main: "#4d63c7",
      dark: "#1746A2",
      light: "#8ea1cc",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#be4a15",
      light: "#f87128",
      dark: "#573810"
    },
    background: {
      default: "#e8e8e8",
      paper: "#fffaf3"
    },success: {
      main: "rgb(53,160,3)",
      dark: "rgb(25,87,1)"
    },
  }
} as BaseThemeOptionsInput<any>)



// #fffec0, #f38925, #CC5500 "#f8a528"